import React, { useState, forwardRef, useImperativeHandle } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, Typography } from '@carto/meridian-ds/components'
import { App, AppTypes } from 'features/apps/types'
import { deleteAppRequest } from 'features/apps/state/appsSlice'
import { useAppDispatch } from 'app/state'

interface AppsDeleteDialogProps {
  app: App
}

export interface AppsDeleteDialogRefProps {
  show: () => void
}

const AppsDeleteDialog: React.ForwardRefRenderFunction<AppsDeleteDialogRefProps, AppsDeleteDialogProps> = (
  props,
  forwardedRef
) => {
  const dispatch = useAppDispatch()
  const [open, setOpen] = useState(false)
  const { app } = props

  function handleClose() {
    setOpen(false)
  }

  function handleDelete() {
    deleteApp()
    handleClose()
  }

  function deleteApp() {
    const { id, type } = app
    if (!id || !type) {
      return
    }
    dispatch(deleteAppRequest({ id, type: type as AppTypes }))
  }

  useImperativeHandle(forwardedRef, () => ({
    show: () => {
      setOpen(true)
    }
  }))

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="apps-delete-form-dialog-title" height="auto">
      <DialogHeader
        id="apps-delete-form-dialog-title"
        title={<FormattedMessage id="apps.cards.deleteDialog.title" />}
        onClose={handleClose}
      />
      <DialogContent>
        <Typography component="span" variant="body2" color="textSecondary">
          <FormattedMessage
            id="apps.cards.deleteDialog.description"
            values={{
              name: (
                <Typography component="span" variant="body2" color="textPrimary">
                  {app.title}
                </Typography>
              )
            }}
          />
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button onClick={handleClose} color="default">
          <FormattedMessage id="common.button.cancel" />
        </Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          <FormattedMessage id="connections.cards.deleteDialog.delete" />
        </Button>
      </DialogFooter>
    </Dialog>
  )
}

export default forwardRef(AppsDeleteDialog)
